import { create } from "zustand"
import { MotivoDemissaoResume } from "../../types/rh/motivoDemissao"
import { rhAPI } from "../../api"

interface MotivoDemissaoState {
  cleanMotivoDemissaoState: () => void
  //RESUME
  motivoDemissaoResume: MotivoDemissaoResume[]
  setMotivoDemissaoResume: () => Promise<void>
  erroMotivoDemissaoResume: boolean
  loadingMotivoDemissaoResume: boolean
  setErroMotivoDemissaoResume: (erro: boolean) => void
}

export const useMotivoDemissaoStore = create<MotivoDemissaoState>((set, get) => ({
  cleanMotivoDemissaoState: () => {
    set(() => ({
      motivoDemissaoResume: [],
      erroMotivoDemissaoResume: false,
      loadingMotivoDemissaoResume: false
    }))
  },
  //RESUME
  motivoDemissaoResume: [],
  erroMotivoDemissaoResume: false,
  loadingMotivoDemissaoResume: false,
  setMotivoDemissaoResume: async () => {
    set(() => ({ loadingMotivoDemissaoResume: true, erroMotivoDemissaoResume: false }))
    const result = await rhAPI.getMotivoDemissaoResume()
    if (result.statusCode == 200 && result.data) {
      set(() => ({ motivoDemissaoResume: result.data }))
    }
    else {
      set(() => ({ erroMotivoDemissaoResume: true, motivoDemissaoResume: [] }))
    }
    set(() => ({ loadingMotivoDemissaoResume: false }))
  },
  setErroMotivoDemissaoResume: (erro: boolean) => {
    set(() => ({ erroMotivoDemissaoResume: erro }))
  },
}))